import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=6c40df36&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
import style0 from "./Table.vue?vue&type=style&index=0&id=6c40df36&prod&lang=css"
import style1 from "./Table.vue?vue&type=style&index=1&id=6c40df36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40df36",
  null
  
)

export default component.exports